import type { PopupWithCampaignResponse } from '@coorum-research/shared-common/api-response/popup.schema'
import type { BootPopupListValues, SearchUserPopupQuery } from '@coorum-research/shared-common/types/popup.type'
import { getPageMeta } from '../utils/page-meta-storage.util'
import http from './http'

export const popupApi = () => {
  const listPopup = async (query?: SearchUserPopupQuery) => {
    const response = await http.get<PopupWithCampaignResponse[]>('/popups', { params: query, paramsSerializer: { indexes: null } })
    return response.data
  }

  /**
   * listPopupと違い
   * - POSTで送信
   * - PageMetaも送る
   */
  const bootListPopup = async () => {
    const pageMeta = getPageMeta()
    const data: BootPopupListValues = {
      meta: pageMeta,
    }
    const response = await http.post<PopupWithCampaignResponse[]>('/boot-popups', data)
    return response.data
  }

  return {
    listPopup,
    bootListPopup,
  }
}
